export default "__VITE_ASSET__5058fe16__"